import { render, staticRenderFns } from "./monthlyProfit.vue?vue&type=template&id=6cb542d0&scoped=true&"
import script from "./monthlyProfit.vue?vue&type=script&lang=js&"
export * from "./monthlyProfit.vue?vue&type=script&lang=js&"
import style0 from "./monthlyProfit.vue?vue&type=style&index=0&id=6cb542d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb542d0",
  null
  
)

export default component.exports